import delay from './delay.js';
import StalePromiseFilter from './StalePromiseFilter.js';

class PromiseDelayer {
  constructor(timeout) {
    this._stalePromiseFilter = new StalePromiseFilter();
    this._timeout = timeout;

    this.swallowOwnRejections = this.swallowOwnRejections.bind(this);
  }

  cancel() {
    this._stalePromiseFilter.cancel();
  }

  ownsRejectionValue(x) {
    return x === 'rescheduled';
  }

  run(promiseFactory) {
    return this._stalePromiseFilter.run(() => delay(this._timeout))
      .then(promiseFactory, x => {
        if (this._stalePromiseFilter.ownsRejectionValue(x)) {
          return Promise.reject('rescheduled');
        }

        return Promise.reject(x);
      });
  }

  swallowOwnRejections(x) {
    if (!this.ownsRejectionValue(x)) {
      return Promise.reject(x);
    }
  }
}

export default PromiseDelayer;